<template>
   <div id="footer" class="text-instruction">
      <div class="d-flex align-items-center justify-content-center py-3">
         <span>©{{ currentYear }} Arden Software Group LLC. All rights reserved.</span>
      </div>
   </div>
</template>

<script>
export default {
   computed: {
      currentYear() {
         return new Date().getFullYear();
      },
   },
};
</script>
